import { MealPlan } from '../types/mealPlan';
import { getPageCache, setPageCache } from './pageCache';
import { nextMealPlansFetch } from './mealPlansFetchGuard';

export const mealPlansCacheKey = (uid: string) => `meal-plans:${uid}`;

/**
 * Optimistically puts a restored meal plan back into the cached list — the
 * undo closures already hold the full plan object, so reappearance must not
 * depend on a refetch round-trip (which can fail or resolve out of order on
 * a slow connection). Writing the cache notifies subscribed surfaces (the
 * dashboard and history page) synchronously.
 *
 * Also invalidates every in-flight list fetch (see mealPlansFetchGuard): any
 * response requested before the restore would clobber the re-added plan.
 * Callers should start a fresh guarded refetch afterwards to reconcile.
 */
export const restoreMealPlanInCache = (uid: string, plan: MealPlan): void => {
  nextMealPlansFetch();
  const key = mealPlansCacheKey(uid);
  const cached = getPageCache<MealPlan[]>(key) ?? [];
  if (!cached.some((p) => p.id === plan.id)) {
    setPageCache(key, [...cached, plan]);
  }
};
